export default __webpack_public_path__ + "static/media/12-2.05097137.mp3";